/**
 * REST paths relative to the axios `baseURL` (must end with `/api`).
 * Keep in sync with:
 * - `ImageController` @Controller("images")
 * - `AuthController` @Controller("auth")
 */
export const apiPaths = {
  auth: {
    google: "/auth/google",
    logout: "/auth/logout",
    me: "/auth/me",
    localKey: "/auth/local-key",
  },
  images: {
    root: "/images",
    upload: "/images/upload",
    stats: "/images/stats",
    trash: "/images/trash",
    byId: (id: string) => `/images/${id}`,
    download: (id: string) => `/images/${id}/download`,
    restore: (id: string) => `/images/${id}/restore`,
    permanent: (id: string) => `/images/${id}/permanent`,
  },
} as const;
